import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import IndexDetail from '@/views/indexdetail'
import ReportIndex from "@/views/report/index"
import ReportDetail from "@/views/report/detail"
import Submit from "@/views/submit/index"
import Test from "@/views/test/index"
import TestResult from "@/views/test/result"
import Login from "@/views/Login"
import Register from "@/views/Register"
import ResetPassword from "@/views/ResetPassword"
import RegisterPerson from "@/views/RegisterPerson"
import ForgotPassword from "@/views/ForgotPassword"

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/indexDetail',
      name: 'IndexDetail',
      component: IndexDetail
    },
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/registerPerson',
      name: 'RegisterPerson',
      component: RegisterPerson
    },
    {
      path: '/resetPassword',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/forgotPassword',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/reportIndex',
      name: 'reportIndex',
      component: ReportIndex
    },
    {
      path: '/reportDetail',
      name: 'reportDetail',
      component: ReportDetail
    },
    {
      path: '/submit',
      name: 'submit',
      component: Submit
    },
    {
      path: '/test',
      name: 'test',
      component: Test
    },
    {
      path: '/testResult',
      name: 'testResult',
      component: TestResult
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js